<template>
  <component :is="component" />
</template>

<script>
import MemberBatchCreate from '@/components/Member/MemberBatchCreate.vue';
import MemberCreate from '@/components/Member/MemberCreate.vue';
import MemberEdit from '@/components/Member/MemberEdit.vue';
import MemberList from '@/components/Member/MemberList.vue';
import { MEMBER_MODE } from '@/utils/constants';

export default {
  name: 'MemberPage',
  computed: {
    component() {
      switch (this.$route.params.action) {
        case MEMBER_MODE.CREATE:
          return MemberCreate;
        case MEMBER_MODE.BATCH_CREATE:
          return MemberBatchCreate;
        case MEMBER_MODE.EDIT:
          return MemberEdit;
        case MEMBER_MODE.LIST:
        default:
          return MemberList;
      }
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
</script>
